module.exports = __webpack_public_path__ + "img/1204.27e48a4d.png";